import axios from './axios.js'
import url from './urls.js'

export default {
  // Dashboard
  getDashboard: (data) => axios.get(`${url.dashboard}?${new URLSearchParams(data).toString()}`),

  // ASR
  convertASR: (data) => axios.post(`${url.asr}?${new URLSearchParams(data.params).toString()}`, data.data, data.headers),
  downloadSubtitling: (data) => axios.post(`${url.asr}/download`, data),

  // Audio File to Text
  getAudioFileList: ({ params, headers, project_id }) => axios.get(`${url.audio_file_to_text_task}/${project_id}?${new URLSearchParams(params).toString()}`, headers),
  getAudioFileResult: ({ params, headers }) => axios.get(`${url.audio_file_to_text_task}/${params.project_id}/${params.task_id}`, headers),
  addNewAudioFile: ({ data, headers }) => axios.post(url.audio_file_to_text_add_file, data, headers),
  deleteAudioFile: ({ params, headers }) => axios.delete(url.audio_file_to_text_task, { headers, data: params }),
  downloadAudioFileTranscription: ({ params, query, headers }) =>
    axios.get(`${url.audio_file_to_text_download}/${params.project_id}/${params.task_id}${params.format ? `/${params.format}` : ''}?${new URLSearchParams(query).toString()}`, headers),
  updateAudioTask: ({ project_id, task_id, params, headers }) => axios.put(`${url.audio_file_to_text_task}/${project_id}/${task_id}`, params, headers),
  updateAudioFileResult: ({ project_id, task_id, transcript_id, params }) => axios.put(`${url.audio_file_to_text_task}/${project_id}/${task_id}/${transcript_id}`, params),

  // Setting - users
  getUserList: (data) => axios.get(`${url.users}?${new URLSearchParams(data).toString()}`),
  updateUser: (data) => axios.put(url.users, data.params, data.headers),
  addUser: (data) => axios.post(url.users, data.params, data.headers),
  deleteUser: (data) => axios.delete(url.users, { data: data.params }),
  importUsersFile: ({ data, headers }) => axios.post(`${url.users}/import`, data, headers),
  getGroupList: (data) => axios.get(`${url.group}?${new URLSearchParams(data).toString()}`),
  addGroup: (data) => axios.post(url.group, data.params),
  updateGroup: (data) => axios.put(url.group, data.params),
  deleteGroup: (data) => axios.delete(url.group, { data: data.params }),

  // Setting - Logs
  getLogs: (data) => axios.get(`${url.logs}?${new URLSearchParams(data).toString()}`),
  downloadLogs: (data) => axios.get(`${url.logs}?${new URLSearchParams(data).toString()}`, { responseType: 'blob' }),

  // auth
  login: (data) => axios.post(url.login, data.params),
  logout: (data) => axios.post(url.logout, data.params),
  verifyOTP: (data) => axios.post(url.otp, data.params),
  verifyToken: (data) => axios.post(url.token, data.params),
  forgotPassword: (data) => axios.post(url.forgot_password, data.params)
}
